import actionCombined from "./Reducer";

import { combineReducers } from "redux";

const mainReducer = combineReducers({
  actionCombined,
});

export default mainReducer;
